import { configureStore } from '@reduxjs/toolkit';
import authSlice from './api/authSlice';
import { navbarPathSlice } from './navbar';
import heroImageReducer from './heroImage/heroImageSlice';
import { cartSlice } from './userApi/cart/cartSlice';
import { productsSlice } from './products/productsSlice';
import { orderSlice } from './order/orderSlice';
import { userSlice } from './user/userSlice';
import wishlistReducer from './wishlist/wishlistSlice';
import quickViewReducer from './quickView/quickViewSlice';
import visitorReducer from './visitor/visitorSlice';
import { categoriesSlice } from './categories/categoriesSlice';

export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        cart: cartSlice.reducer,
        navbarPath: navbarPathSlice.reducer,
        products: productsSlice.reducer,
        order: orderSlice.reducer,
        user: userSlice.reducer,
        wishlist: wishlistReducer,
        quickView: quickViewReducer,
        visitor: visitorReducer,
        categories: categoriesSlice.reducer,
        heroImage: heroImageReducer,
    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authApi.middleware),
});

export type IRootState = ReturnType<typeof store.getState>;
export type IAppDispatch = typeof store.dispatch;
